import React from 'react';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import { Link } from 'react-router-dom'
import { SeoSignImg, ExperienceImg3, ExperienceImg4, MissionImg, CompanyImg } from '../../Constant/Index';
const AboutUs = () => {


    return (
        <>
            <Header />
            {/* AboutUs Section Start Here */}
            <section className="about-exp-ceo pt-5 mt-4">
                <div className="container">
                    <div className="top-heading text-center">
                        <h2 className="lg-heading">About Us</h2>
                    </div>
                    <div className="section-start pt-5">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12 order-1 order-lg-0 mt-5 mt-lg-0">
                                <div className="ceo-message-text pe-lg-5">

                                    <h2 className="md-heading">CEO message</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.</p>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                    <figure className='signature-img'>
                                        <img src={SeoSignImg} className="img-fluid" alt="..." />
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 order-0 order-lg-1">
                                <div className="experience-right-data">
                                    <figure className='experience-images order-1'>
                                        <img src={ExperienceImg4} alt="" className="top-left-img" />
                                        <img src={ExperienceImg3} alt="" className="bottom-right-img" />
                                    </figure>
                                    <div className="experience-box primary-text order-0 mb-3 mb-md-0">
                                        <div className="headings">
                                            <h2 className="md-heading">25+</h2><h6 className="xs-heading small">Year</h6>
                                        </div>
                                        <p className="text crop-2-lines">We Have More than years of Experience</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* AboutUs Section End Here */}
            {/* Mission and Goals Section Start here */}
            <section className="mission-goals">
                <div className="container">
                    <div className="mission-golas-start">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-12">
                                <figure className="main-img">
                                    <img src={MissionImg} alt="" className="theimg w-100 img-fluid" />
                                </figure>
                            </div>
                            <div className="col-lg-6 col-md-12">
                                <div className="mission-goal-text primary-text mt-4">
                                    <h2 className="md-heading captalize-text">mission and goals</h2>
                                    <div className="text-here">
                                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
                                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                                        <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Mission and Goals Section End here */}
            {/* Company Section Start Here */}
            <section className="company-section">
                <div className="container">
                    <div className="company-start">
                        <div className="row align-items-start">
                            <div className="col-md-6">
                                <div className="comany-text">
                                    <div className="top-txt">
                                        <h2 className="md-heading">Company</h2>
                                        <p className="md-text">Welcome to Webtrans Logistics, Inc</p>
                                    </div>
                                    <ul className="yearly-update-list">
                                        <li className="single-year">
                                            <span className="year-name">2014</span>
                                            <p className="text">Adipiscing elit, sed do eiusmod tempoet dolore magna aliqua.</p>
                                        </li>
                                        <li className="single-year">
                                            <span className="year-name">2013</span>
                                            <p className="text">Adipiscing elit, sed do eiusmod tempoet dolore magna aliqua.</p>
                                        </li>
                                        <li className="single-year">
                                            <span className="year-name">2012</span>
                                            <p className="text">Adipiscing elit, sed do eiusmod tempoet dolore magna aliqua.</p>
                                        </li>
                                        <li className="single-year">
                                            <span className="year-name">2011</span>
                                            <p className="text">Adipiscing elit, sed do eiusmod tempoet dolore magna aliqua.</p>
                                        </li>
                                        <li className="single-year">
                                            <span className="year-name">2007</span>
                                            <p className="text">Adipiscing elit, sed do eiusmod tempoet dolore magna aliqua.</p>
                                        </li>
                                        <li className="single-year">
                                            <span className="year-name">2006</span>
                                            <p className="text">Adipiscing elit, sed do eiusmod tempoet dolore magna aliqua.</p>
                                        </li>
                                        <li className="single-year">
                                            <span className="year-name">2000</span>
                                            <p className="text">Adipiscing elit, sed do eiusmod tempoet dolore magna aliqua.</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 mt-5 mt-lg-0">
                                <figure className="company-img">
                                    <img src={CompanyImg} alt="" className="the-img w-100 img-fluid" />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Company Section End Here */}
            {/* Footer Included Here */}
            <Footer />
            {/* Footer Included Here */}
        </>
    )
}
export default AboutUs;